var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87711 9.15222L1.8401 6.11521C1.49876 5.77388 0.947373 5.77388 0.606038 6.11521C0.264703 6.45655 0.264703 7.00794 0.606038 7.34927L4.26445 11.0077C4.60579 11.349 5.15718 11.349 5.49851 11.0077L14.7583 1.74787C15.0997 1.40654 15.0997 0.855149 14.7583 0.513814C14.417 0.172479 13.8656 0.172479 13.5243 0.513814L4.87711 9.15222Z",
    fill: "#59576B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.d9c822f06a2cf7bd5e432fe85a86dca6.svg";
export { ForwardRef as ReactComponent };